import { useIsMobileShell } from "@/hooks/use-is-mobile-shell"
import { ReadingsPanelDesktop } from "./readings-panel-desktop"
import { ReadingsPanelMobile } from "./readings-panel-mobile"
import type { DeviceSettings, SensorReading } from "@/types/device"

interface ReadingsPanelProps {
  deviceId: number
  reading: SensorReading
  settings: DeviceSettings | null
  lastSeenAt: string | null
}

export function ReadingsPanel(props: ReadingsPanelProps) {
  const isMobile = useIsMobileShell()
  return isMobile ? (
    <ReadingsPanelMobile {...props} />
  ) : (
    <ReadingsPanelDesktop reading={props.reading} settings={props.settings} />
  )
}
